import { format } from 'date-fns'

export function getFullDateOutput(startDate?: Date, endDate?: Date, closingText = 'Offer subject to availability.') {
  let fullDateOutput = ''
  if (startDate && endDate) {
    fullDateOutput = `Offer valid for delivery from ${format(startDate, 'dd/MM/yyyy')} until ${format(endDate, 'dd/MM/yyyy')}. `
  } else if (endDate) {
    fullDateOutput = `Offer valid for delivery until ${format(endDate, 'dd/MM/yyyy')}. `
  }
  fullDateOutput += closingText
  return fullDateOutput
}